import { render, staticRenderFns } from "./ProgramsTab.vue?vue&type=template&id=d722cc80&scoped=true"
import script from "./ProgramsTab.vue?vue&type=script&lang=js"
export * from "./ProgramsTab.vue?vue&type=script&lang=js"
import style0 from "./ProgramsTab.vue?vue&type=style&index=0&id=d722cc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d722cc80",
  null
  
)

export default component.exports